import { GuaranteesGridEffects } from '@ruby/modules/guarantees/store/effects/guarantees-grid.effects';

export const effects = [
  GuaranteesGridEffects
];
